import reducer from './reports.reducer';
import * as selector from './reports.selector';
import * as constant from './reports.constant';
import subscriber from './reports.subscriber';
import saga from './reports.saga';

export default {
  reducer,
  constant,
  selector,
  name: constant.NAME,
  subscriber,
  saga,
};
